// The payment-method set — the ONLY list. See .claude/features/payment-methods.md.
//
// 'offline'         -> Bank Transfer
// 'card'            -> Card (manually recorded)
// 'cash'            -> Cash in hand (manually recorded, like Transfer)
// 'usdt'            -> USDT / crypto (manually recorded, like Transfer)
// 'stripe_link'     -> Stripe link (we generate the link, customer pays)
// 'stripe_terminal' -> POS (we charge a physical Stripe Terminal reader)
// `feature` (optional) = an App\Constants\Features key; the option is hidden
// when the store's plan doesn't include it. Transfer, Card, Cash and USDT are
// manual recording, which is core and always available.
export const PAYMENT_METHOD_OPTIONS = [
  { value: 'offline',         label: 'Transfer' },
  { value: 'card',            label: 'Card' },
  { value: 'cash',            label: 'Cash' },
  { value: 'usdt',            label: 'USDT' },
  { value: 'stripe_link',     label: 'Stripe Link', feature: 'stripe_payments' },
  { value: 'stripe_terminal', label: 'POS',         feature: 'stripe_terminal' },
];

// Methods recorded by hand on surfaces that pay money OUT or record money
// already received (commissions, the /sell flow, expert fees) — Stripe Link
// and POS collect from a customer, so they never apply there.
export const MANUAL_PAYMENT_METHODS = ['offline', 'card', 'cash', 'usdt'];
